const Show = ({ children, when = false }) => {
  if (when) {
    return children;
  }

  return null;
};

export default Show;
